export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAIL = "UPLOAD_IMAGE_FAIL";
export const UPLOAD_IMAGE_RESET = "UPLOAD_IMAGE_RESET";

export const REMOVE_IMAGE_REQUEST = "REMOVE_IMAGE_REQUEST";
export const REMOVE_IMAGE_SUCCESS = "REMOVE_IMAGE_SUCCESS";
export const REMOVE_IMAGE_FAIL = "REMOVE_IMAGE_FAIL";
export const REMOVE_IMAGE_RESET = "REMOVE_IMAGE_RESET";

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";
export const CREATE_PRODUCT_RESET = "CREATE_PRODUCT_RESET";

export const LIST_PRODUCT_REQUEST = "LIST_PRODUCT_REQUEST";
export const LIST_PRODUCT_SUCCESS = "LIST_PRODUCT_SUCCESS";
export const LIST_PRODUCT_FAIL = "LIST_PRODUCT_FAIL";
export const LIST_PRODUCT_RESET = "LIST_PRODUCT_RESET";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";
export const DELETE_PRODUCT_RESET = "DELETE_PRODUCT_RESET";

export const DETAILS_PRODUCT_REQUEST = "DETAILS_PRODUCT_REQUEST";
export const DETAILS_PRODUCT_SUCCESS = "DETAILS_PRODUCT_SUCCESS";
export const DETAILS_PRODUCT_FAIL = "DETAILS_PRODUCT_FAIL";
export const DETAILS_PRODUCT_RESET = "DETAILS_PRODUCT_RESET";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";

export const COUNT_PRODUCTS_REQUEST = "COUNT_PRODUCTS_REQUEST";
export const COUNT_PRODUCTS_SUCCESS = "COUNT_PRODUCTS_SUCCESS";
export const COUNT_PRODUCTS_FAIL = "COUNT_PRODUCTS_FAIL";
export const COUNT_PRODUCTS_RESET = "COUNT_PRODUCTS_RESET";

export const LIST_PRODUCT_ADMIN_REQUEST = "LIST_PRODUCT_ADMIN_REQUEST";
export const LIST_PRODUCT_ADMIN_SUCCESS = "LIST_PRODUCT_ADMIN_SUCCESS";
export const LIST_PRODUCT_ADMIN_FAIL = "LIST_PRODUCT_ADMIN_FAIL";
